import type { ReCAPTCHAbleForm } from '@/Google/ReCaptcha.d';

export default {
    id: "google-recaptcha",
    import: () => import("./../Google/ReCaptcha"),
    evaluate: () => {

        const forms: Array<ReCAPTCHAbleForm> = [
            {
                form: document.getElementById('newsletter-subscribe') as HTMLFormElement,
                siteKey: document.querySelector('#newsletter-subscribe [name=google-recaptcha]') as HTMLInputElement,
            },
            {
                form: document.getElementById('ecommerce-review-form') as HTMLFormElement,
                siteKey: document.querySelector('#ecommerce-review-form [name=google-recaptcha]') as HTMLInputElement,
            },
        ];

        for (const k in forms) {

            const item = forms[k];

            if (item?.form && item?.siteKey) {
                return forms;
            }
        }

        return false;
    }
};
